import { useState } from 'react';
import {
  Accordion,
  AccordionProps,
  Col,
  Container,
  Row,
} from 'react-bootstrap';
import { VerticalStepsType } from '../../types';
import { formatPrice } from '../../utils/utils';

export type Props = {
  props: VerticalStepsType;
};

export type SimpleAccordionProps = AccordionProps & Props;

const SimpleAccordion = ({ props }: SimpleAccordionProps) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  const collapsedHandler = () => {
    setIsCollapsed((state) => !state);
  };

  return (
    <Accordion defaultActiveKey="1">
      <Accordion.Item
        eventKey="0"
        className={`simple-accordion-custom ${
          !isCollapsed ? 'accordion-shadow' : ''
        }`}
      >
        <Accordion.Header
          className="accordion-header"
          onClick={collapsedHandler}
        >
          <Container className="header-container p-0">
            <Container className="p-0 mb-5">
              <h5 className="text-sub1 fw-normal">{`${props.title} ${props.date}`}</h5>
            </Container>
            <Container className="first-subtitle d-flex align-items-center p-0 text-sub1 fw-light">
              <div className="d-flex ms-7 ">{props.firstSubTitle.title}</div>
              <div className="ms-auto d-flex flex-column align-items-end">
                <span className="fw-normal">
                  {`${formatPrice(Number(props.firstSubTitle.amount), 'en-US', {
                    currency: 'USD',
                    style: 'currency',
                    minimumFractionDigits: 2,
                  })}`}
                </span>
                <span className="text-light-grey-normal mt-lg-1">
                  (monthly)
                </span>
              </div>
            </Container>
          </Container>
        </Accordion.Header>
        <Accordion.Body className="py-0 text-sub1 fw-light">
          <Container className="p-0 ps-13">
            {props.firstSubTitle.plans.map((prop: any, index) => (
              <Row key={index} className="pb-7">
                <Col>{prop.title}</Col>
                <Col className="fw-normal d-flex justify-content-end">
                  {`${formatPrice(Number(prop.amount), 'en-US', {
                    currency: 'USD',
                    style: 'currency',
                    minimumFractionDigits: 2,
                  })}`}
                </Col>
              </Row>
            ))}
          </Container>
        </Accordion.Body>
        <Row>
          <Col className="second-subtitle d-flex mx-11 ps-11 pe-0 pt-5 pb-9 text-sub1 fw-light border-top">
            <div>{props.secondSubTitle.title}</div>
            <div className="ms-auto d-flex flex-column align-items-end">
              <span className="fw-normal">{`${formatPrice(
                Number(props.secondSubTitle.amount),
                'en-US',
                {
                  currency: 'USD',
                  style: 'currency',
                  minimumFractionDigits: 2,
                }
              )}`}</span>
              <span className="text-light-grey-normal mt-lg-1 text-nowrap">
                (monthly)
              </span>
            </div>
          </Col>
        </Row>
      </Accordion.Item>
    </Accordion>
  );
};

export default SimpleAccordion;
